<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import DxButton from 'devextreme-vue/button';
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import Loader from "../components/loader";
import CustomStore from 'devextreme/data/custom_store';
import api from "@/axios";
import Swal from "sweetalert2";
import Multiselect from "@vueform/multiselect";

import {
  DxDataGrid,
  DxColumn,
  DxColumnChooser,
  DxColumnFixing,
  DxSelection,
  DxExport,
  DxStateStoring,
  DxGroupPanel, DxGrouping,
  DxPager, DxFilterRow, DxRemoteOperations
} from 'devextreme-vue/data-grid';
import moment from "moment";
import {getBaseUrl} from "@/helpers/baseUrl";


export default {

  components: { Layout, PageHeader, DxButton,
    DxDataGrid, DxColumn, DxColumnChooser, DxColumnFixing, DxSelection, DxExport,
    DxStateStoring, DxGroupPanel, DxGrouping, DxToolbar, DxItem, DxPager,  DxFilterRow, DxRemoteOperations,
    Loader, Multiselect
  },
  data() {

    return {
      title: "Produtos (Estoque Endereço)",
      items: [
        {
          text: "Estoque",
          href: "/"
        },
        {
          text: "Produtos (Estoque Endereço)",
          active: true
        }
      ],
      dataList: null,
      totalList: 0,
      updating: false,

      empresaData: null,

      wmsEnderecoSel: null,
      showModalWmsEndereco: false,
      dtListPesqWmsEndereco: null,

    };
  },

  created() {

  },

  computed: {
    dataGrid: function() {
      return this.$refs.dataGridRefKey.instance
    }
  },

  mounted() {
    console.log('mounted produto-list-endereco_0')
    this.atualizaDataList()
  },

  methods: {


    pesqWmsEndereco(evt) {
      console.log('pesqWmsEndereco')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        //this.orctoData.condpgto = ''
        api.get(`${getBaseUrl()}api/enderpes`, {
          params: { q: query, origem: "produtoestoque", origem_id: null }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtListPesqWmsEndereco = res.data
        })
      }
    },

    escolheuWmsEndereco() {
      console.log('escolheuWmsEndereco')
      this.loadingWmsEndereco = true
      console.log(this.wmsEnderecoSel)
      this.showModalWmsEndereco = false

      this.title = `(${this.totalList}) Produtos (Estoque Endereço): ${this.wmsEnderecoSel}`
      this.atualizaDataList()


    },


    confirmarAssocRomaNovo(){
      console.log('confirmarAssocRomaNovo')
      // console.log(this.wmsosList)
      const idsAtualizar = this.dataGrid.getSelectedRowKeys()
      console.log('idsAtualizar')
      console.log(idsAtualizar)
      this.updating = true
      api.post(`${getBaseUrl()}api/wmsromawmsosnv`, {
        idsData: idsAtualizar
      }).then((res) => {
        console.log('then axios')
        console.log(res)
        this.showAssocRoma = false
        this.updating = false
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações salvas com sucesso!",
          showConfirmButton: false,
          timer: 1500
        }).then(() => {
          const routeData = this.$router.resolve(`/wmsromaneio/editar/` + res.data[0].id)
          window.open(routeData.href, '_blank')
        })
      })
    },

    pesqRomaneio(evt){
      console.log('pesqRomaneio')
      console.log(evt)
      let query = evt
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/wmsromapesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqRoma = res.data
        });
      }
    },


    carregouGrid(e){
      console.log('carregouGrid')
      this.totalList = e.component.totalCount()
      this.title = `(${this.totalList}) Produtos (Estoque Endereço): ${this.wmsEnderecoSel === null ? 'SELECIONAR ENDEREÇO' : this.wmsEnderecoSel}`
    },


    atualizaDataList(){
      console.log('atualizaDataList_prodEst')
      console.log(this.wmsEnderecoSel)


        const ender = this.wmsEnderecoSel
        this.dataList = new CustomStore({
          key: "produto_id",
          load: function(loadOptions){
            let queryArray = []
            if (loadOptions['filter']) {
              if (loadOptions['filter'][1] === 'and' || loadOptions['filter'][1] === 'or') {
                loadOptions['filter'].forEach((value) => {
                  // console.log('value_filter')
                  // console.log(value)
                  // console.log(value[0])
                  // console.log(typeof (value))
                  if (typeof (value) === "object") {
                    queryArray.push({
                      cmp: value[0],
                      opr: value[1],
                      val: value[2],
                    })
                  }
                })
              } else {
                queryArray.push({
                  cmp: loadOptions['filter'][0],
                  opr: loadOptions['filter'][1],
                  val: loadOptions['filter'][2],
                })
              }
            }
            const paramsReq = {
              'skip': loadOptions['skip'],
              'take': loadOptions['take'],
              'filter': queryArray,
              'sort': loadOptions['sort'],
              'ender': ender

            }
            console.log('paramsReq')
            console.log(paramsReq)
            return api.get(`${getBaseUrl()}api/prodestender`, {
              params: paramsReq
            }).then(response => {
              console.log('response.data_0')
              console.log(response)
              return {
                data: response.data[0],
                totalCount: response.data[1],
              }
            })
          },
        })

    },



    mudouExib(){
      console.log('mudouExib')
      if (!this.updating)
        this.atualizaDataList()
    },

    novoProduto(){
      console.log('novoProduto')
      this.$router.push(`/produto/editar/0`)
    },

    onRowDblClick(row) {
      console.log('onRowDblClick')
      let idData = row.key
      console.log(idData)
      // this.$router.push(`/movimento/editar/${idData}`)
      const routeData = this.$router.resolve(`/movimento/editar/${idData}`)
      window.open(routeData.href, '_blank')
    },

    onCellPrepared(e) {
      if (e.rowType === "data") {
        if (e.column.dataField === "mov_status") {
          const valStatus = e.data.mov_status
          let corStatus = 'rgba(78,59,0,0.5)'
          switch (valStatus) {
            case 'EL':
              corStatus = 'rgba(78,59,0,0.5)'
              break
            case 'CF':
              corStatus = 'rgba(0,58,78,0.5)'
              break
            case 'ENP':
              corStatus = 'rgba(33,78,0,0.5)'
              break
            case 'ECR':
              corStatus = 'rgba(146,20,0,0.5)'
              break
            case 'EAT':
              corStatus = 'rgba(146,20,0,0.5)'
              break
            case 'NED':
              corStatus = 'rgba(146,73,0,0.5)'
              break
            case 'NEF':
              corStatus = 'rgba(146,20,0,0.5)'
              break
            case 'SCT':
              corStatus = 'rgba(146,111,0,0.5)'
              break
            case 'CCT':
              corStatus = 'rgba(0,58,78,0.5)'
              break
            case 'TRA':
              corStatus = 'rgba(146,20,0,0.5)'
              break
            case 'CAN':
              corStatus = 'rgba(146,20,0,0.5)'
              break
          }
          e.cellElement.style.cssText = `color: white; background-color: ${corStatus}`;

        } else if (e.column.dataField === "diasentrega") {
          const valDias = e.data.diasentrega
          let corDias = null
          if (!valDias) {
            corDias = 'rgba(0,0,0,0.38)'
          } else if (valDias < 0) {
            corDias = 'rgba(146,20,0,0.5)'
          } else if (valDias > 0) {
            corDias = 'rgba(33,78,0,0.5)'
          }

          e.cellElement.style.cssText = `color: white; background-color: ${corDias}`;
        }
      }
    },


    onExporting(e){
      console.log('onExporting')
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('plan1');
      exportDataGrid({
        component: e.component,
        worksheet,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), this.title + '.xlsx');
        });
      });
      e.cancel = true;
    },

    refeFormTable(){
      console.log('refeFormTable')
      this.dataGrid.state(null);

    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },

    nomeStatus(e) {

      switch (e.value) {

        case 'EL':
          return 'Elaboração(EL)'

        case 'PR':                   // desativado
          return 'Ordem Saída (PR)'  // desativado

        case 'OS':
          return 'Ordem Saída (OS)'

        case 'CF':
          return 'Pedido Conferido (CF)'
        case 'NEM':
          return 'Nota Fiscal Emitida (NEM)'
        case 'NLO':
          return 'Não Encontrado (NLO)'
        case 'ENP':
          return 'Entregue no Prazo (ENP)'
        case 'ECR':
          return 'Entregue com Ressalva (ECR)'
        case 'EAT':
          return 'Entregue com Atraso (EAT)'
        case 'CCT':
          return 'Com CTe (CCT)'
        case 'TRA':
          return 'Transferido (TRA)'
        case 'CAN':
          return 'Cancelado (CAN)'


        case 'SCT':
          return 'Sem CTe'
        case 'NEP':
          return 'Dentro do Prazo (Não Entregue)'
        case 'NEF':
          return 'Fora do Prazo (Não Entregue)'
      }

      return e.value
    },



    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    }

  },


};

</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items"  @click="showModalWmsEndereco = true"/>

    <div>

      <DxToolbar>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="refresh"
              hint="Redefinir formatação de tabela para padrão"
              :on-click="refeFormTable"/>
        </DxItem>


        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="plus"
              hint="Novo Produto"
              text="Novo Produto"
              :on-click="novoProduto"/>


        </DxItem>


      </DxToolbar>
    </div>

    <Loader v-if="updating" style="min-height: 300px;">
    </Loader>

    <div class="mt-2" v-if="!updating">

      <DxDataGrid
          ref="dataGridRefKey"
          :data-source="dataList"
          :show-borders="true"
          :focused-row-enabled="true"
          :column-auto-width="true"
          :show-row-lines="true"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :row-alternation-enabled="true"
          @cell-prepared="onCellPrepared"
          @row-dbl-click="onRowDblClick"
          @content-ready="carregouGrid"
          @exporting="onExporting">

        <DxRemoteOperations
            :filtering="true"
            :paging="true"
            :sorting="true"
            :summary="true"
            :grouping="false"
            :group-paging="false"
        />


        <DxColumnChooser :enabled="true"/>
        <DxColumnFixing :enabled="true"/>
        <DxFilterRow :visible="true" />


        <DxSelection mode="multiple"/>
        <DxExport
            :enabled="true"
            :allow-export-selected-data="true"/>
        <DxStateStoring
            :enabled="true"
            type="sessionStorage"
            storage-key="strProdutoEstoqEnderList"/>

        <DxGroupPanel :visible="true"/>
        <DxGrouping />


        <DxColumn sort-order="desc"
                  data-field="produto_id"
                  caption="ID"
                  alignment="left"
                  data-type="number"
                  :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                  :allowHeaderFiltering="false">
        </DxColumn>

        <DxColumn data-field="produto_codigo"
                  caption="Código"
                  alignment="left"
                  data-type="text"
                  :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                  :allowHeaderFiltering="false"/>

        <DxColumn data-field="produtosaldoloc_endwms"
                  caption="Endereço"
                  alignment="left"
                  data-type="text"
                  :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                  :allowHeaderFiltering="false"/>


        <DxColumn data-field="produto_descricao"
                  caption="Descrição"
                  alignment="left"
                  data-type="text"
                  :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                  :allowHeaderFiltering="false"/>


        <DxColumn data-field="produtosaldoloc_lote"
                  caption="Lote"
                  alignment="left"
                  data-type="text"
                  :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                  :allowHeaderFiltering="false"/>


        <DxColumn
            data-field="produtosaldoloc_dtvalid"
            caption="Validade"
            alignment="right"
            data-type="datetime"
            format="dd/MM/yyyy"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>


        <DxColumn
            data-field="produtosaldoloc_saldo"
            caption="Saldo"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true" />





        <DxPager
            :visible="true"
            :show-page-size-selector="true"
            :allowed-page-sizes="[10, 30, 50, 100]"
            :show-navigation-buttons="true"
            :show-info="true"/>


      </DxDataGrid>


    </div>




    <b-modal title="Detalhes Endereço (WMS)" v-model="showModalWmsEndereco" centered hide-footer>

      <div class="col-md-12 mt-2">
        <div class="mb-3">
          <span>Selecionar Endereço</span>

          <multiselect id="formapgto"
                       @search-change="pesqWmsEndereco"
                       @select="escolheuWmsEndereco"
                       v-model="wmsEnderecoSel"
                       placeholder="Pesquisar forma de pagamento"
                       :options="dtListPesqWmsEndereco"
                       :searchable="true"
                       label="descricao"
                       track-by="descricao"
                       value-prop="descricao">
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4" >

                  </span>
                </div>
                <div class="mt-2 font-size-20">{{ slotProps.option.descricao }}</div>
                <span class="mx-4" >
                </span>
                <span class="mx-4" >
                </span>
                <div class="align-items-end text-end align-content-end">{{ formatDateTime(slotProps.option.created_at) }} </div>

              </div>
            </template>
          </multiselect>

        </div>
      </div>


      <div v-if="wmsEnderecoSel">


        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalWmsEndereco = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
<!--          -->
        </div>
      </div>

    </b-modal>



  </Layout>
</template>